import React, { useContext, useMemo } from 'react'

import type { MenuOptionType } from '@vividseats/vivid-ui-kit'

import filterContext from '@/components/pages/production/components/context'
import { FilterFields } from '@/components/pages/production/components/context/types'
import { trackEvent } from '@/utils/analytics/ga360'

import Filter from '../filter'

import styles from './styles.module.scss'

const QUANTITY_OPTIONS: MenuOptionType[] = [
    { value: '0', label: 'Any Quantity' },
    { value: '1', label: '1 ticket' },
    { value: '2', label: '2 tickets' },
    { value: '3', label: '3 tickets' },
    { value: '4', label: '4 tickets' },
    { value: '5', label: '5 tickets' },
    { value: '6', label: '6 tickets' },
    { value: '7', label: '7 tickets' },
    { value: '8', label: '8+ tickets' },
]

const QuantityFilter: React.FC = () => {
    const {
        state: { quantityFilterState, modifiedFilterList },
        dispatch: { onQuantityFilterChangeAction: onQuantityFilterChange },
    } = useContext(filterContext)

    const selectedOption: any = useMemo(
        () =>
            QUANTITY_OPTIONS.find((option) => option.value === quantityFilterState.quantity.toString()) ||
            QUANTITY_OPTIONS[0],
        [quantityFilterState.quantity],
    )

    const handleChange = (option: any) => {
        onQuantityFilterChange({ quantity: parseInt(option.value) })
        trackEvent('ExposeFilterUse', 'Sort By quantity button clicked', option.label)
    }

    const handleTrackClick = () => {
        trackEvent('ExposeFilterUse', 'Sort By quantity button clicked')
    }

    return (
        <Filter
            classes={{ menuBody: styles.quantityFilterMenuBody }}
            handleChange={handleChange}
            handleTrackClick={handleTrackClick}
            options={QUANTITY_OPTIONS}
            selectedOption={selectedOption}
            isChanged={modifiedFilterList.includes(FilterFields.Quantity)}
        />
    )
}

export default QuantityFilter
